module.exports = __webpack_public_path__ + "img/logimg.a2235209.png";